export const defaultColor = '#6b30fa';
export const white = '#000';
